<template>
  <Tables :stickyHeader="true" ref="tableGridPrimeiroAdiantamento"
        :columns="['Funcionários Vinculados','Lote','Status','Data de inclusão','Valor do Adiantamento']"
        :showReload="false"
        v-on:Load="Onload"
        :showButtonNew="true"
        :newHeaderStatus="false"
        :showHeader="true"
        >
        <tr v-for="data in ArrayPrimeiroAdiantamento" :key="data.id">
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data.id)" :status="1" :value="data.funcionario == null ? 'N/D' :  data.funcionario" />
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data.id)" :status="1" :value="data.lote == null ? 'N/D' :  data.lote" />
            <TableColumn :IsTextLocked="data.status == 5" :class="{'deixar-negrito' : data.status == 5}" :IsTextYellow="data.status != 4 && data.status != 5"   :IsTextGreen="data.status == 4"    v-on:Edit="onSelect(data.id)" :status="1" :value="data.primeiroAdiantamento == 1 ? data.statusDespesa == 0 ? 'N/D' : data.statusDespesa : data.statusDespesa" />
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data.id)" :status="1" :value="formataData(data.dataInclusao == null ? 0 : data.dataInclusao)" />
            <TableColumn v-if="local !== 'escl'" :IsText="true"   v-on:Edit="onSelect(data.id)" :status="1" :value="formatMoney(data.valor == null ? 0 : data.valor)" />
            <TableColumn v-else :IsText="true"   v-on:Edit="onSelect(data.id)" :status="1" :value="formatMoney(data.valor == null ? 0 : data.valor)" />
          </tr>
    </Tables>
</template>

<script>
import AdvanceFirstTrip from './AdvanceFirstTrip'
export default AdvanceFirstTrip
</script>

<style scoped>
.deixar-negrito {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/components/Tabs/AdvanceFirstTrip/AdvanceFirstTrip.vue